import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/Guest-blank.webp";
import ThumbImg from "../../assets/images/conversations/blank.png";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: rr-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .rr-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .rr-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .rr-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .rr-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .rr-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .rr-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rr-hero__title.rr-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .rr-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .rr-hero__spotify.rr-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .rr-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .rr-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .rr-hero__right.rr-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .rr-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .rr-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .rr-yt-thumb:hover img { opacity: 0.85; }
  .rr-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .rr-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .rr-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .rr-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .rr-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rr-body.rr-visible { opacity: 1; transform: translateY(0); }
  .rr-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .rr-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .rr-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rr-guest.rr-visible { opacity: 1; transform: translateY(0); }
  .rr-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .rr-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .rr-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .rr-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .rr-inner { padding-left: 32px; padding-right: 32px; }
    .rr-hero { padding-top: 32px; padding-bottom: 48px; }
    .rr-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .rr-hero__title { font-size: 24px; }
    .rr-hero__left { gap: 16px; }
    .rr-guest__title { font-size: 24px; margin-bottom: 24px; }
    .rr-guest__photo-bg { width: 260px; height: 300px; }
    .rr-guest__name { font-size: 24px; margin-top: 18px; }
    .rr-body__para { font-size: 14px; margin-bottom: 12px; }
    .rr-body { padding-bottom: 48px; }
    .rr-guest { padding-bottom: 48px; }
    .rr-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .rr-inner { padding-left: 16px; padding-right: 16px; }
    .rr-hero { padding-top: 51px; padding-bottom: 30px; }
    .rr-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .rr-hero__left { gap: 30px; }
    .rr-hero__title { font-size: 30px; }
    .rr-body__para { font-size: 16px; margin-bottom: 10px; }
    .rr-guest__title { font-size: 30px; margin-bottom: 20px;text-align:left; }
    .rr-guest__photo-bg { width: 100%; height: 386px; }
    .rr-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .rr-body { padding-bottom: 30px; }
    .rr-guest { padding-bottom: 30px; }
    .rr-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("rr-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="rr-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 39 Ranjita Ravi"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="rr-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 39 Ranjita Ravi thumbnail" />
      <div className="rr-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="rr-hero">
      <div className="rr-inner">
        <div className="rr-hero__grid">
          <div className="rr-hero__left">
            <h1 ref={titleRef} className="rr-hero__title">
              EP 39 | Can Electric be more ta fun? | Orxa Energies | Ranjita RAVI
            </h1>
            <div ref={spotifyRef} className="rr-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/7nEFAk2h4jIe51zlsuN56d?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 39 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="rr-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="rr-body">
      <div className="rr-inner">
        <p className="rr-body__para">
          The motorcycling spirit is a passion that runs deep. It's a love for the open road and the freedom it brings. It's the feeling of the wind against your skin and the rush of adrenaline in your heart. So, what would happen when a hardcore biker desires to challenge the age-old industry and aspires to build one of the most impressive motorcycles to come out of India? Today, we speak with Ranjita Ravi, the co-founder and CEO at Orxa Energies, who is building Mantis, an all-electric performance bike, and much more. You don't want to miss this one.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="rr-guest">
      <div className="rr-inner">
        <h2 className="rr-guest__title">Our Guest</h2>
        <div>
          <div className="rr-guest__photo-bg">
            <img src={GuestImg} alt="Ranjita Ravi" />
          </div>
          <p className="rr-guest__name">Ranjita RAVI</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep39RanjitaRavi() {
  return (
    <>
      <style>{CSS}</style>
      <div className="rr-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}